module.exports = __webpack_public_path__ + "img/d_3.d4f42b5e.png";